export const RESOURCE_TYPE_TEXT = 'pwa-app/components/text';
export const RESOURCE_TYPE_FORM_INPUT = 'pwa-app/components/forminput';
export const RESOURCE_TYPE_FORM_INPUT_PASSWORD = 'pwa-app/components/forminputpassword';
export const RESOURCE_TYPE_NOTIFICATIONS_INBOX = 'pwa-app/components/notificationsinbox';
